module.exports = __webpack_public_path__ + "static/img/logo.b60d5139.png";